module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('remote.crumbs.L1')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_body"
  }, [_c('div', {
    staticClass: "apply_bg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/header.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_msg"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('remote.crumbs.L1')))]), _vm._v(" "), (_vm.isEnLanguage) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg1')))]), _vm._v(" "), _c('span', {
    staticClass: "msg_place first-a"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg2')))]), _c('span', {
    staticClass: "msg_place"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg3')))]), _vm._v(" "), _c('span', {
    staticClass: "msg_place first-a"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg4')))]), _c('span', {
    staticClass: "msg_place"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg5')))]), _vm._v(" "), _c('span', {
    staticClass: "msg_place first-a"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg7')))]), _c('span', {
    staticClass: "msg_place"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg8')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg9')))])]) : _vm._e(), _vm._v(" "), (_vm.isZhLanguage) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg1')))]), _vm._v(" "), _c('span', {
    staticClass: "msg_place first-a"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg2')))]), _c('span', {
    staticClass: "msg_place first-a"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg4')))]), _c('span', {
    staticClass: "msg_place"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg6')))]), _c('span', {
    staticClass: "msg_place first-a"
  }, [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg7')))]), _c('span', [_vm._v(_vm._s(_vm.$t('apply.remotePayMsg9')))])]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.btnStatus
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.applyStatus !== 0 ? _vm.$t('apply.applyed') : _vm.$t('apply.apply')))])])]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction"
  }, [_c('div', {
    staticClass: "apply_introduction_why"
  }, [_c('p', {
    staticClass: "apply_introduction_title"
  }, [_vm._v(_vm._s(_vm.$t('apply.title')))]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail"
  }, [_c('div', {
    staticClass: "apply_introduction_detail_one detail"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_1.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_one_title introduct"
  }, [_c('p', [_vm._v("1.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('apply.list1')))])])]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_two detail"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/img_2.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_two_title introduct"
  }, [_c('p', [_vm._v("2.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('apply.list2')))])])]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_three detail"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_3.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_three_title introduct"
  }, [_c('p', [_vm._v("3.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('apply.list3')))])])]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_four detail"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_4.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_four_title introduct"
  }, [_c('p', [_vm._v("4.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('apply.list4')))])])]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_five detail"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_5.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_detail_five_title introduct"
  }, [_c('p', [_vm._v("5.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('apply.list5')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "apply_introduction_how"
  }, [_c('p', {
    staticClass: "apply_remotepay"
  }, [_vm._v(_vm._s(_vm.$t('apply.howtoApply')))]), _vm._v(" "), _c('div', {
    staticClass: "dashed_line"
  }), _vm._v(" "), _c('div', {
    staticClass: "apply_remotepay_details"
  }, [_c('div', {
    staticClass: "apply_remotepay_detail detail_one"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_2_1.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("1." + _vm._s(_vm.$t('apply.method1')))])]), _vm._v(" "), _c('div', {
    staticClass: "apply_remotepay_detail detail_two"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_2_2.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("2." + _vm._s(_vm.$t('apply.method2')))])]), _vm._v(" "), _c('div', {
    staticClass: "apply_remotepay_detail detail_three"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_2_3.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("3." + _vm._s(_vm.$t('apply.method3')))])]), _vm._v(" "), _c('div', {
    staticClass: "apply_remotepay_detail detail_four"
  }, [_c('img', {
    attrs: {
      "src": require("./img/img_2_4.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("4." + _vm._s(_vm.$t('apply.method4')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-176b5846"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/apply/apply.vue
// module id = 906
// module chunks = 0